export default [
  'company',
  'deal',
  'person'
]
